import moment from "moment";

const month = [
  "Jan",
  "Feb",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const fullmonth = [
  "January",
  "Febuary",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const dateFormatCol = (date) => { //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "")
    return "NA";
    return moment(date).tz("Asia/Kolkata").format("DD MMM YYYY")
};

export const isActive = (isActive) => { //12th June 2020, 10:00 AM
  if (isActive === undefined || isActive === null || isActive === "" )
    return "NA";
  else if(isActive===false){
    return 'Not Active'
  }else{
    return 'Active'
  }
  // var dt = new Date(date);
  // return dt.getDate() + " " + month[dt.getMonth()] + " " + dt.getFullYear();
};

export const timeFormatCol = (date) => { //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "")
    return "NA";
  return moment(date).tz("Asia/Kolkata").format("hh:mm A");
};

export const gameArrayPrint = (data) => { //12th June 2020, 10:00 AM
  if (data.length<=0)
    return "NA";
  
 return data[0]
};

export const prizePoolInfoPrint = (data) => { //12th June 2020, 10:00 AM
  if (data === undefined || data === null || data.length === 0)
    return "NA";

  return JSON.stringify(data)
};

export const timeFormatCol2 = (date) => { //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "")
    return "NA";
  var dt = new Date(date);
  return date;
};

export const momentTimeFormatCol = (date) => { //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "")
    return "";
  return moment(date).format('hh:mm a');
};

export const timeInSecondsFormatCol = (date) => { //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "")
    return "";
  var dt = new Date(date);
  return formatAMPMInSeconds(new Date(date));
};

export const dateTimeFormatCol = (date) => { //12th June 2020, 10:00 AM
  var dt = new Date(date);
  return dt.getDate() + " " + month[dt.getMonth()] + " " + dt.getFullYear() + " " + formatAMPM(new Date(date));
};

export function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export function formatAMPMInSeconds(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
  return strTime;
}

export const dateandTime = (date) => { //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "")
    return "-";
  // var dt = new Date(date);
  return moment(date).format('D MMM YYYY h:mm a');
};
export const DDate = (date) => {
  //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "") return "-";
  // var dt = new Date(date);
  return moment(date).format("D MMM YYYY");
};
export const DTime = (date) => {
  //12th June 2020, 10:00 AM
  if (date === undefined || date === null || date === "") return "-";
  // var dt = new Date(date);
  return moment(date).format("h:mm a");
};

export const lastDateTimeFormatCol = (date) => { //12th June 2020, 10:00 AM
  console.log("date",date)
  if (date?.length > 0) {
      // Get the last object in the array
      const lastMessage = date[date?.length - 1];

      // Extract the dateAndTime from the last message
      const lastMessageDateAndTime = lastMessage.dateAndTime;

      var dt = new Date(lastMessageDateAndTime);
      return dt.getDate() + " " + month[dt.getMonth()] + " " + dt.getFullYear() + " " + formatAMPM(new Date(lastMessageDateAndTime)); // This line will not execute if the array is empty
  }
  return "-"
};
export const jsonObjectToString = (pgData) => { //12th June 2020, 10:00 AM
  return JSON.stringify(pgData);

};